import tw, { styled } from 'twin.macro';

export const PageTitle = styled.h1`
  ${tw`font-heading text-2xl font-normal text-gray-800 text-center uppercase pb-6`}
  ${tw`md:text-left md:font-thin md:text-3xl`}
`;
